<template>
    <div class="container box-like">
        <div class="button-box">
            <a-space size="small">
                <a-button icon="plus" type="primary" @click="onAdd">新建卡</a-button>
                <a-button icon="interaction" type="primary" @click="onDistribution">分配 / 作废</a-button>
                <a-popover title="导出选项" trigger="click" @visibleChange="onResetExportParams">
                    <a-space style="width: 220px" direction="vertical" size="small" slot="content">
                        <a-input type="text" placeholder="请输入卡号前缀" v-model="exportPrefix"></a-input>
                        <a-input-number :min="0" type="text" placeholder="请输入最小值" style="width: 100%" v-model="exportMin"></a-input-number>
                        <a-input-number :min="0" type="text" placeholder="请输入最大值" style="width: 100%" v-model="exportMax"></a-input-number>
                        <a-button :disabled="exportPrefix === '' || exportMin === '' || exportMax === ''" @click="onExport(false)">导出基本信息</a-button>
                        <a-button type="primary" :disabled="exportPrefix === '' || exportMin === '' || exportMax === ''" @click="onExport(true)">导出详细信息</a-button>
                    </a-space>
                    <a-button icon="export">导出卡信息</a-button>
                </a-popover>
            </a-space>
            <a-button icon="retweet" @click="onFilterAllReset">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 600 , y: 66 * 10}" :pagination="pageConfig">
            <!-- slot对应配置文件中customRender的内容 -->
            <div slot="c-qrcode" slot-scope="text">
                <a :href="text" target="_blank">点击打开二维码</a>
            </div>
            <div slot="c-action" slot-scope="text, record" style="display: flex;">
                <a-button type="primary" style="margin-right: 4px;" @click="onEdit(record)">编辑</a-button>
                <a-button type="danger" @click="onDelete(record.id)">删除</a-button>
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]" v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''" v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <div>
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button size="small" icon="retweet" style="width: 90px" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>

        <a-modal title="编辑信息" :visible="showModal" okText="提交" cancelText="返回" @ok="submit" :maskClosable="false" centered @cancel="showModal = false">
            <a-form-model ref="modelForm" layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :model="formModelContent">
                <a-form-model-item :label="item.title" :prop="`${index}.value`" :rules="item.rules" v-for="(item, index) in formModelContent" :key="index">
                    <a-input :type="item.aliasType" v-model="item.value" :placeholder="item.placeholder || `请输入${item.title}`" v-if="item.type === 'input'" />
                    <a-input-number v-model="item.value" :min="item.min" :max="item.max" :step="item.step || 1" :placeholder="item.placeholder || `请输入${item.title}`" style="width: 100%"
                        v-if="item.type === 'inputNumber'" />
                    <a-select :placeholder="item.placeholder || `请选择${item.title}`" :mode="item.multi ? 'multiple' : ''" v-model="item.value" v-if="item.type === 'select'">
                        <a-select-option :value="item2.id" v-for="(item2, index2) in item.items" :key="index2">{{item2.name}}</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap,
    cardBasicType,
    cardUserType,
    cardUsingType
} from '@/common/project-config'
import {
    formModel,
    formModelActiveCard,
    columns
} from './card-list.conf'

export default {
    name: 'card_card-list',
    computed: {
        ...mapState('stored', ['userInfo']),
        // eslint-disable-next-line object-shorthand
        formModelContent: function () {
            return this.formModelType ? this.formModel : this.formModelActiveCard
        }
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 编辑内容类型，true = 基础编辑内容，false = 分配 / 作废卡
            formModelType: false,
            // 编辑内容配置，在配置文件里
            formModel: { ...formModel },
            formModelActiveCard: { ...formModelActiveCard },
            // 表格配置，在配置文件里
            columns: [...columns],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 10,
                total: 0,
                pageSizeOptions: ['10', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 卡基础状态
            cardBasicType,
            // 导出选项
            exportPrefix: '',
            exportMin: '',
            exportMax: ''
        }
    },
    created() {

    },
    mounted() {
        this.onInit(true)
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit(reMap) {
            // 开始loading
            this.setLoading('页面加载中...')
            if (reMap) {
                await this.initMap()
            }
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.card.get, {
                status: this.userInfo.stationId,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                ...this.filterItems
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s }
                _s.status = stationMap[_s.status]
                _s.type = this.cardBasicType[_s.type]
                _s.user_type = cardUserType[_s.user_type]
                _s.admin_type = cardUsingType[_s.admin_type]
                return _s
            })
            // 其它的逻辑写在这里
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 气站列表，仅选出前4个气站
            res = Object.entries(stationMap).slice(0, 4).map(([id, name]) => ({
                id,
                name
            }))
            this.formModelActiveCard.status.items = res

            // 卡类型
            res = await this.$util.request(this.$ctrl.card.getType, {
                status: this.userInfo.stationId,
                page: 1,
                limit: 9999
            })
            index = this.columns.findIndex((s) => s.filterIndex === 'clip_typeid')
            this.columns[index].items = this.formModel.clip_typeid.items = res.data.data

            // 卡号前缀
            res = await this.$util.request(this.$ctrl.card.getCardPrefix, {
                status: this.userInfo.stationId,
                page: 1,
                limit: 9999
            })
            this.formModelActiveCard.title.items = res.data
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = ''
                this.filterItems[key] = undefined
                this.pageConfig.current = 1
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onAdd() {
            this.selectedId = -1
            this.formModelType = true
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
            })
        },
        onDistribution() {
            this.selectedId = -1
            this.formModelType = false
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
            })
        },
        onEdit(e) {
            this.selectedId = e.id
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
                Object.entries(e).forEach(([k, v]) => {
                    if (this.formModel.hasOwnProperty(k)) {
                        this.formModel[k].value = v
                    }
                })
            })
        },
        onDelete(e) {
            this.$confirm({
                title: '提示',
                content: '确定要删除吗？',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.admin_manager.del, {
                        id: e
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '删除成功',
                                centered: true
                            })
                            if (this.tableData.length <= 1 && this.pageConfig.current > 1) {
                                this.pageConfig.current -= 1
                            }
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '删除失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        submit() {
            this.$refs.modelForm.validate((valid) => {
                if (valid) {
                    let modelValues = Object.entries(this.formModelContent).reduce((p, [k, v]) => {
                        p[k] = v.value
                        return p
                    }, {})
                    let requestUrl = this.formModelType ? this.$ctrl.card.edit : this.$ctrl.card.activeCard
                    this.$util.request(requestUrl, {
                        status: this.userInfo.stationId,
                        id: this.selectedId > 0 ? this.selectedId : undefined,
                        ...modelValues
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '提交成功',
                                centered: true
                            })
                            this.showModal = false
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '提交失败',
                                centered: true
                            })
                        }
                    })
                } else {
                    return false
                }
            })
        },
        onChangeActiveType(type, { card, id }) {
            this.$confirm({
                title: '提示',
                content: `卡号${card}，修改激活状态为：${this.activeType[type]}，确定要修改吗`,
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.card.edit, {
                        status: this.userInfo.stationId,
                        id,
                        type
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '修改成功',
                                centered: true
                            })
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '修改失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        onExport(isDetail) {
            let urlBase = isDetail ? 'cliexportall' : 'cliexport'
            let win = window.open(
                `http://xm.lcxxjs.cn/api/${urlBase}?status=${this.userInfo.stationId}&title=${this.exportPrefix}&min=${this.exportMin}&max=${this.exportMax}`
            )
            if (this.exportMax - this.exportMin >= 15000) {
                win.alert('导出数据量过大的情况下需要一定时间处理，请不要关闭这个页面，处理完成后会弹出下载窗口')
            }
        },
        onResetExportParams() {
            this.exportPrefix = ''
            this.exportMin = ''
            this.exportMax = ''
        }
    }
}
</script>

<style scoped lang="less">
@import "./card-list.less";
</style>
